import { render, staticRenderFns } from "./OutstandingOrdersModal.vue?vue&type=template&id=b0860f20&"
import script from "./OutstandingOrdersModal.vue?vue&type=script&lang=js&"
export * from "./OutstandingOrdersModal.vue?vue&type=script&lang=js&"
import style0 from "./OutstandingOrdersModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OutstandingOrdersModal.vue"
export default component.exports